import TrainingList from 'training/containers/TrainingList';
import CurrentTrainingList from 'training/containers/CurrentTrainingList';

export const RouteConfig = [
  {
    path: '/training',
    component: TrainingList
  },
  {
    path: '/training/overview',
    component: CurrentTrainingList
  },
]
